export default "__VITE_ASSET__ewZDpPQY__"